import { useTranslation } from 'react-i18next'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@vapor/material'
import HoauGrid from './hoau-grid'

export default function DialogHoauGrid({ open, onClose, tenantId, propertyId, reservationId }: { open: boolean; onClose: () => void; tenantId: string; propertyId: string; reservationId: string }) {
  const { t } = useTranslation()

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>{t('pms.booking.reservation.hoau.title')}</DialogTitle>
      <DialogContent>
        <HoauGrid tenantId={tenantId} propertyId={propertyId} reservationId={reservationId} />
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={onClose}>
          {t('commons.close')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
